// Adjustment.js
// Component for Adjustment view

// Imports
import React from 'react';
import { InputGroup, Tooltip, Position, Button, Checkbox, Alignment } from '@blueprintjs/core';
import PropTypes from 'prop-types';

// Component Class
// Shows Adjustment entry
class Adjustment extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    var order = this.props.orderData;
    var value = order.getAdjustmentValue();
    var desc = order.getAdjustmentDescription();
    var enabled = value !== 0 || desc !== null;
    
    if (enabled && value === null)
      value = 0;

    this.state = {
      enabled: enabled,
      text: desc,
      value: enabled ? value.toFixed(2) : null,
      editing: false,
    };
  }

  // Method called after fields change trigger an update of the order's adjustments
  updateAdjustment = () => {
    if (!this.state.enabled)
      this.props.setAdjustment(null, null);
    else {
      var text = this.state.text !== null ? this.state.text.trim() : "";
      if (text === "")
        text = null;
      var value = Number.parseFloat(this.state.value);
      if (Number.isNaN(value) && text !== null)
        value = 0;
      this.props.setAdjustment(value, text);
    }
  }

  // Called when checkbox value changes
  checkboxChanged = (event) => {
    if (event.target.checked) {
      if (!this.state.value)
        this.setState({value: 0});
    }
    
    this.setState({enabled: event.target.checked}, () => { this.updateAdjustment(); });
  }

  // Called when text field changes
  onTextChange = (event) => {
    this.setState({text: event.target.value});
  }
  
  // Called when text field changes
  onTextBlur = (event) => {
    this.setState({text: event.target.value}, () => { this.updateAdjustment(); });
  }

  // Called when value field changes
  onValueChange = (event) => {
    var value = Number.parseFloat(event.target.value);
    var valid = false;
    if (!Number.isNaN(value)) {
      valid = true;
    }
    this.setState({value: event.target.value, valid: valid, editing: true});
  }

  // Called when user finishes editing value field
  onValueBlur = () => {    
    var value = Number.parseFloat(this.state.value);
    if (Number.isNaN(value))
      value = 0;
    this.setState({value: value.toFixed(2), valid: true, editing: false}, () => { this.updateAdjustment(); });
  }

  // Renders Component
  render() {
    var info = (
      <div>
        Esse campo pode ser usado em duas situações:<br />
        - Quando se deseja conceder um desconto global no pedido de um cliente. <br />
        - Quando se deseja fazer um acerto de contas por produtos já enviados e não contabilizados.<br />
        <br />
        Em ambos os casos, deve ser preenchido um valor (negativo em caso de desconto e positivo em caso de ajuste) e, opcionalmente, <br />
        uma justificativa para o ajuste, que será incluída no pedido.<br />
        <br />
        Idealmente, no caso de solicitações extras, o ideal é criar e fechar um pedido separado apenas com os produtos já enviados.<br />
        Isso permite um controle melhor nos dados do que está sendo vendido e, como o pedido seria fechado antes de abrir um novo,<br />
        não teria impacto na lista de compras.<br />
        <br />
        Ainda assim, em alguns casos pode ser mais conveniente simplesmente fazer a anotação e o acrescimo de valor no pedido corrente.
      </div>
    );

    var valueField = this.state.value ? this.state.value : Number(0).toFixed(2);
    return (
      <table className="pt-html-table pt-html-table-striped pt-small" style={{width: '90%'}}>
        <thead>
          <tr>
            <th colSpan={3}>
              <Tooltip content={info} position={Position.RIGHT}>
                <Button rightIcon="info-sign" small minimal>
                  <b>Ajuste de Valores</b>
                </Button>
              </Tooltip>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width='20px' vertical-align='center' align='center'>
            <Checkbox
              large
              checked={this.state.enabled}
              onChange={this.checkboxChanged}
            />
            </td><td width='75%'>
            <InputGroup
              disabled={!this.state.enabled}
              align={Alignment.LEFT}
              placeholder="Justificativa (Opcional)"
              value={this.state.text ? this.state.text : "" }
              onChange={this.onTextChange}
              onBlur={this.onTextBlur}
            />
            </td><td>
            <InputGroup
              disabled={!this.state.enabled}
              align={Alignment.RIGHT}
              placeholder="Valor"
              value={valueField}
              leftIcon="dollar"
              onChange={this.onValueChange}
              onBlur={this.onValueBlur}
            />
          </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

// Required Properties
Adjustment.propTypes = {
  orderData: PropTypes.object.isRequired,
  setAdjustment: PropTypes.func.isRequired,
}

// Exports
export default Adjustment;


// WEBPACK FOOTER //
// ./src/components/OrderView/Adjustment.js